module.exports = __webpack_public_path__ + "static/media/ntb.b27c5595.jpg";